import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { vuetify } from './plugins/vuetify';
import './styles/globals.css';

/**
 * URL クエリパラメータによる開発用リセット。
 *
 * `?reset=1` (または `?reset=sample`) を付けてアクセスすると、
 * propertyStore の localStorage を全消去してからアプリ起動。
 * propertyStore は空状態を検出してサンプルをフレッシュ再注入する。
 * 全 localStorage を消したい場合は `?reset=all`。
 *
 * 副作用 (localStorage削除) は Pinia store 初期化より前に実行する必要があるため、
 * createApp/use(pinia) の前に呼ぶ。
 */
function handleResetQuery() {
  try {
    const params = new URLSearchParams(window.location.search);
    const reset = params.get('reset');
    if (!reset) return;
    if (reset === 'all') {
      localStorage.clear();
    } else {
      // 'sample' または '1' その他: サンプル/物件データのみクリア
      localStorage.removeItem('evacuation-map.properties.v1');
      localStorage.removeItem('evacuation-map.sample.version');
    }
    // URL から `reset` を除去 (リロード時の無限ループ防止 + 履歴に残さない)
    params.delete('reset');
    const newSearch = params.toString();
    const newUrl =
      window.location.pathname +
      (newSearch ? `?${newSearch}` : '') +
      window.location.hash;
    window.history.replaceState(null, '', newUrl);
    console.info(`[reset] localStorage cleaned (mode=${reset})`);
  } catch (e) {
    console.warn('[reset] failed to process ?reset=', e);
  }
}

handleResetQuery();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(vuetify);
app.mount('#app');
